import { Component, inject, Input } from '@angular/core';
import { Payment, PaymentResponseModel } from '../../models/event.model';
import { EventViewModel } from '../../models-views/event.view.model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { environment } from '../../../environments/environment';
interface IModalData {
  id: number;
  name: string;
}
@Component({
  selector: 'app-cet-payments-details',
  standalone: false,
  templateUrl: './cet-payments-details.component.html',
  styleUrl: './cet-payments-details.component.scss'
})
export class CetPaymentsDetailsComponent {
  loading:boolean = true
  modalData?: IModalData;
  payment: any;
  paymentDetailsModel = new BehaviorSubject<Payment>(new Payment())

  constructor(private vm:EventViewModel,private modalRef: NzModalRef,) {
    this.modalData = inject(NZ_MODAL_DATA); // Moved here
    this.vm.cetPaymentsDetailsComponent = this;
    this.vm.subscribeToPaymentDetails(this.paymentDetailsModel)
  }
  
  ngOnInit():void {
    console.log(this.modalData)

   this.modalData  && this.vm.getPaymentById(this.modalData.id)
  }

  getStatusColor(status: string): string {
    switch (status?.toLowerCase()) {
      case 'completed': return 'green';
      case 'pending': return 'gold';
      case 'failed': return 'red';
      default: return 'default';
    }
  }

  paymentDetailRecieved(){
    this.payment = this.paymentDetailsModel.value
    this.loading = false
    console.log(this.payment)
  }

  getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }

  close(): void {
    this.modalRef.close(false);
  }
}
